export default __webpack_public_path__ + "static/media/contact.ba685d7c.svg";